module.exports = __webpack_public_path__ + "img/copy-darkGrey.70f56e07.svg";